import { format } from 'date-fns/esm/fp';

export const formatMonthDay = (date) => (date ? format('MMM d', date) : '');

export const formatMonthDayNumeric = (date) =>
  date ? format('M/d', date) : '';

export const formatCalendarDate = (date) =>
  date ? format('y-MM-dd', date) : '';

export const formatCalendarDatetime = (date) =>
  date ? format('y-MM-dd HH:mm:ss', date) : '';

export const formatLongDate = (date) => (date ? format('MMM d, y', date) : '');

export const formatMonthName = (date) => (date ? format('MMMM', date) : '');

export const formatFancyMonthDay = (date) =>
  date ? format('LLLL do', date) : '';

export const formatFancyMonthShortDay = (date, includeSuffix = true) =>
  date ? format(`LLL${includeSuffix ? ' do' : ' d'}`, date) : '';

export const formatGameDateRange = ({ startDate: start, endDate: end }) => {
  const startDate = new Date(start);
  const endDate = new Date(end);
  const startMonth = format('MMM', startDate);
  const endMonth = format('MMM', endDate);
  return startMonth === endMonth
    ? `${startMonth} ${format(' d', startDate)}-${format('d', endDate)}`
    : `${startMonth} ${format(' d', startDate)} - ${endMonth} ${format(
        ' d',
        endDate
      )}`;
};
